/// <amd-module name="Repos/Views/Import/Components/Push/Push" />
import * as React from "react";

import { format } from "VSS/Core/Util/String";

import { Button } from "VSSUI/Button";
import { ClipboardButton } from "VSSUI/Clipboard";
import { Observer } from "VSSUI/Observer";
import { TextField } from "VSSUI/TextField";
import { css } from "VSSUI/Util";

import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";

import { RepoProtocol } from "Repos/Common/Types";
import { IVCViewModelDataProviderService } from "Repos/Common/VCViewModelDataProviderService";

import * as Resources from "Repos/Views/Import/Resources";

import { PushProps } from "./Push.Props";

const pushFormat = "git remote add origin {0}{1}git push -u origin --all";

export class Push extends VssComponent<PushProps> {
    private httpPush?: string;
    private sshPush?: string;

    constructor(props: PushProps, context: IVssComponentContext) {
        super(props, context);

        const vcViewModelDataProviderService = context.pageContext.getService<IVCViewModelDataProviderService>("IVCViewModelDataProviderService");
        const vcViewModel = vcViewModelDataProviderService.getViewModel();

        // Initialize all the fields used in the page.
        this.httpPush = vcViewModel.cloneUrl ? format(pushFormat, vcViewModel.cloneUrl, String.fromCharCode(10)) : undefined;
        this.sshPush = vcViewModel.sshUrl ? format(pushFormat, vcViewModel.sshUrl, String.fromCharCode(10)) : undefined;
    }

    public render() {
        return (
            <Observer protocol={this.props.protocol}>
                {(props: { protocol: RepoProtocol }) => (
                    <div className={css(this.props.className, "push margin-vertical-4")}>
                        <div className="margin-bottom-4">
                            {this.httpPush ? (
                                <Button
                                    onClick={() => (this.props.protocol.value = RepoProtocol.https)}
                                    primary={props.protocol === RepoProtocol.https}
                                    text="HTTPS"
                                />
                            ) : null}
                            {this.sshPush ? (
                                <Button
                                    onClick={() => (this.props.protocol.value = RepoProtocol.ssh)}
                                    primary={props.protocol === RepoProtocol.ssh}
                                    text="SSH"
                                />
                            ) : null}
                        </div>
                        <div className="flex-row">
                            <div className="flex-grow">
                                <TextField
                                    ariaLabelledBy={this.props.ariaLabelledBy}
                                    multiline={true}
                                    readOnly={true}
                                    rows={2}
                                    spellCheck={false}
                                    value={props.protocol === RepoProtocol.https ? this.httpPush : this.sshPush}
                                />
                            </div>
                            &nbsp;
                            <ClipboardButton
                                getContent={() => (props.protocol === RepoProtocol.https ? this.httpPush : this.sshPush) || ""}
                                showCopiedTooltip={true}
                                tooltipProps={{ text: Resources.CopyPushToClipboard }}
                            />
                        </div>
                    </div>
                )}
            </Observer>
        );
    }
}
